// src/constants/meta.js - 수정
export const SEO_CONFIG = {
  // 네이버 기준 (우선)
  naver: {
    title: "쉽고 빠른 3D프린팅 출력·제작 플랫폼 | 엠피니티 (MPNITE)",      // 15자
    description: "AI 자동견적으로 3D프린팅, CNC가공, 사출성형 제조 견적을 즉시 확인하세요. 시제품부터 양산까지 엠피니티 (MPNITE) 가 함께합니다.", // 30자
  },
  // 구글 기준 (보조)
  google: {
    title: "엠쉽고 빠른 3D프린팅 출력·제작 플랫폼 | 엠피니티 (MPNITE)",
    description: "AI 자동견적으로 3D프린팅, CNC가공, 사출성형 제조 견적을 즉시 확인하세요. 시제품부터 양산까지 엠피니티 (MPNITE) 가 함께합니다.",
  },
  brand: {
    name: "엠피니티 (MPNITE)",
    nameKo: "엠피니티", 
    nameEn: "MPNITE",
  },
  keywords: "3D프린팅,AI자동견적,시제품제작,CNC가공,사출성형,엠피니티,MPNITE",
  author: "엠피니티 (MPNITE)",
  siteUrl: "https://mpnite.com",
};

// 네이버 우선 정책이므로 기본값은 네이버 기준 사용
export const defaultMeta = [
  { name: "title", content: SEO_CONFIG.naver.title },
  { name: "description", content: SEO_CONFIG.naver.description },
  { name: "keywords", content: SEO_CONFIG.keywords },
  { name: "author", content: SEO_CONFIG.author },
];